import React from 'react'

import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import './home.css'

const Home = () => (
    <>
      <Helmet>
        <link rel="canonical" href="https://sisu.ryansshane.com" />
        <title>sisu</title>
        <meta name="description" content="sisu" />
      </Helmet>
      <nav className='navbar' role='navigation'>
        <div className='topbar'>
          <Link to='/info' className='info link'>information</Link>
          <Link to='/reserve' className='reserve link'>reservations</Link>
        </div>
        <div className='botbar'>
          <Link to='/chef' className='chef link'>chef</Link>
          <Link to='/contact' className='contact link'>contact</Link>
        </div>
      </nav>
      <div className='hero'>
        <h1><Link to='/info' className='center'>s<span>I</span>su</Link></h1>
      </div>
    </>
  );

export default Home;